export enum JOB_ROUTE_NAMES {
  JOB_NEW = "job-new",
  JOB_HISTORY = "job-historyindex",
}
